// src/core/i18n/client-config.ts
import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// Client-side i18n initialization
export const initClientI18n = (lng: string) => {
  return i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng,
      fallbackLng: "en-US",
      supportedLngs: ["en-US", "zh-TW"],
      ns: ["common"],
      defaultNS: "common",
      backend: {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
      },
    });
};

export const i18nInstance = i18n;
